import type { Meta, StoryObj } from "@storybook/react";
import noop from "lodash/noop";

import type { BaseActiveOnboardingCardContentProps } from "@/ui/components/onboarding/v2/cards/BaseActiveOnboardingCardContent";
import { BaseActiveOnboardingCardContent } from "@/ui/components/onboarding/v2/cards/BaseActiveOnboardingCardContent";
import { BaseOnboardingCard } from "@/ui/components/onboarding/v2/cards/BaseOnboardingCard";
import { Button, FAIconName, Text } from "@/ui/core";
import {
  getOnboardingIllustrationIcon,
  OnboardingIllustrationName,
} from "@/ui/theme/icons/illustrations/onboarding";
import { ColorToken } from "@/ui/theme/tokens";

const StoryMeta: Meta<BaseActiveOnboardingCardContentProps> = {
  title: "Components/Onboarding/Cards/Base Active Content Shell",
  component: BaseActiveOnboardingCardContent,
  args: {
    caption: "Step 2",
    description:
      "The essentials your care team needs before they can plan anything.",
    duration: "About 7 min",
    icon: getOnboardingIllustrationIcon({
      iconName: OnboardingIllustrationName.Placeholder,
    }),
    testID: "story",
    title: "Your profile",
  },
  argTypes: {
    captionColor: {
      control: "select",
      options: [
        ColorToken.Primary100,
        ColorToken.TertiaryMarigoldText,
        ColorToken.Secondary70,
      ],
    },
  },
  decorators: [
    (Story) => (
      <BaseOnboardingCard borderRadius="large" hasShadow testID="story">
        <Story />
      </BaseOnboardingCard>
    ),
  ],
};

type Story = StoryObj<BaseActiveOnboardingCardContentProps>;

const Default: Story = {};

const WithAction: Story = {
  args: {
    action: (
      <Button
        isFullWidth
        onPress={noop}
        rightIcon={FAIconName.ArrowRight}
        testID="story"
        title="Start now"
        variant="primary"
      />
    ),
  },
};

const WithBody: Story = {
  args: {
    action: (
      <Button
        isFullWidth
        onPress={noop}
        rightIcon={FAIconName.ArrowRight}
        testID="story"
        title="Start now"
        variant="primary"
      />
    ),
    children: (
      <Text color={ColorToken.NeutralPrimary} testID="story" variant="caption">
        Body slot content goes here
      </Text>
    ),
  },
};

const NoDuration: Story = {
  args: {
    caption: "Review complete",
    captionColor: ColorToken.Primary100,
    description: undefined,
    duration: undefined,
    title: "Continue onboarding",
  },
};

const BoldDescription: Story = {
  args: {
    caption: "Pending",
    captionColor: ColorToken.TertiaryMarigoldText,
    description:
      "A provider is reading your clinical picture. **While you wait, our full library of videos and articles is yours to browse.**",
    duration: "1-2 business days",
    title: "Medical review",
  },
};

export { BoldDescription, Default, NoDuration, WithAction, WithBody };
export default StoryMeta;
